export const juneUppercase = "rqa";
export default {juneUppercase};